import { Box, Divider, FormControlLabel, Switch } from "@mui/material";
import { useDisguise } from "../../../context/disguiseContext";

export const DashboardFooter = () => {
  const { enabled, setEnabled } = useDisguise();

  return (
    <Box component="footer" sx={{ mt: 6, mb: 3 }}>
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={enabled}
              onChange={(e) => setEnabled(e.target.checked)}
            />
          }
          label="Discreet mode"
        />
      </Box>
    </Box>
  );
};
